import type { ReactNode } from "react";
import { Icon } from "@jkast90/kast-common/ui";

// The player's pop-ups (settings and the guide): a titled card with its
// close button in the top-right corner and a body that scrolls. Where each
// one sits is up to its class in index.css; how it looks is `.popup`'s.
export default function Popup({
  title,
  onClose,
  open = true,
  className = "",
  children,
}: {
  title: string;
  onClose: () => void;
  /** Closed pop-ups stay mounted (the settings dock is a portal target). */
  open?: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <section className={`popup ${className}${open ? " open" : ""}`} aria-label={title}>
      <div className="popup-head">
        <h2>{title}</h2>
        <button
          type="button"
          className="btn icon-btn popup-close"
          aria-label={`Close ${title.toLowerCase()}`}
          onClick={onClose}
        >
          <Icon name="close" size={20} className="icon" />
        </button>
      </div>
      <div className="popup-body">{children}</div>
    </section>
  );
}
